var _path, _g, _path2, _path3, _g2, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.87667 20.1886V18.876H5.25141V17.5634H3.93879V16.2507H2.6272V13.6265H1.31458V8.37707H2.6272V5.75181H3.93879V4.43918H5.25141V3.12656H7.87667V1.81498H13.1261V3.12656H15.7514V4.43918H17.063V5.75181H18.3756V8.37707H19.6882V13.6265H18.3756V16.2507H17.063V17.5634H15.7514V18.876H13.1261V20.1886H7.87667Z",
    fill: "#00E2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.18775 20.1888H7.87512V21.5014H9.18775V20.1888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5018 20.1887H9.18921V21.5013H10.5018V20.1887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8126 20.1888H10.5V21.5014H11.8126V20.1888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.1268 20.1887H11.8142V21.5013H13.1268V20.1887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.6871 12.3141V13.6267H20.9998V12.3141H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.6871 11.0014V12.3141H20.9998V11.0014H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.6871 9.68866V11.0013H20.9998V9.68866H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.6871 8.37621V9.68884H20.9998V8.37621H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.4392 18.876H13.1266V20.1886H14.4392V18.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.7517 18.876H14.4391V20.1886H15.7517V18.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.3765 14.9393V16.252H19.6891V14.9393H18.3765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.3765 13.6267V14.9393H19.6891V13.6267H18.3765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17.0641 17.5634H15.7515V18.8761H17.0641V17.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.3749 16.2507H17.0623V17.5633H18.3749V16.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M14.4392 1.81508H13.1266V3.12771H14.4392V1.81508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M15.7517 1.81508H14.4391V3.12771H15.7517V1.81508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M19.6871 7.06464V5.75201H18.3745V7.06464H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M19.6871 8.37614V7.06351H18.3745V8.37614H19.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M17.0641 3.12657H15.7515V4.4392H17.0641V3.12657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M18.3749 4.43956H17.0623V5.75219H18.3749V4.43956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M11.814 1.81401L13.1266 1.81401V0.501386L11.814 0.501386V1.81401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M10.5016 1.81412L11.8142 1.81412V0.501493L10.5016 0.501493V1.81412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M9.18737 1.81401L10.5 1.81401V0.501386L9.18737 0.501386V1.81401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M7.87316 1.81412L9.18579 1.81412V0.501493L7.87316 0.501493V1.81412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M1.31287 9.68976V8.37713H0.000237942V9.68976H1.31287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M1.31458 11.0015V9.68884H0.00194359V11.0015H1.31458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M1.31458 12.3139V11.0013H0.00194693V12.3139H1.31458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M1.31458 13.6266V12.314H0.00194693V13.6266H1.31458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M6.56249 3.12657H7.87512V1.81394L6.56249 1.81394V3.12657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.2517 3.12657H6.56433V1.81394L5.2517 1.81394V3.12657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M2.62695 7.06464V5.75201H1.31432V7.06464H2.62695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M2.62524 8.3772V7.06458H1.31262V8.3772H2.62524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M3.94091 4.43956H5.25354V3.12693H3.94091V4.43956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M2.62512 5.75212H3.93774V4.43949H2.62512V5.75212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M6.56249 20.1888H7.87512V18.8762H6.56249V20.1888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M5.2517 20.1887H6.56433V18.876H5.2517V20.1887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M1.31458 14.9382V16.2508H2.6272V14.9382H1.31458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M1.31458 13.6255V14.9381H2.6272V13.6255H1.31458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M3.94091 18.876H5.25354V17.5634H3.94091V18.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M2.62512 17.5645H3.93774V16.2519H2.62512V17.5645Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M7.21983 7.72039H5.90825V9.03302H4.59562V12.9699H5.90825V14.2825H7.21983V15.5951H8.53246V16.9077H12.4703V15.5951H13.7819V14.2825H15.0946V16.2509H17.063V17.5635H15.7514V18.8762H13.1261V20.1888H7.87667V18.8762H5.25141V17.5635H3.93878V16.2509H2.6272V13.6267H1.31458V8.37723H2.6272V5.75197H3.93878V4.43935H5.25141V6.40777H7.21983V7.72039Z",
    fill: "#22A2C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M18.3749 5.75212H17.0623V7.06475H18.3749V5.75212Z",
    fill: "#22A2C4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M9.84485 15.5952H8.53223V16.9078H9.84485V15.5952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M11.1572 15.5953H9.8446V16.9079H11.1572V15.5953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M12.4697 15.5953H11.1571V16.9079H12.4697V15.5953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M4.59485 11.6575V12.9701H5.90748V11.6575H4.59485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M4.59485 10.3448V11.6574H5.90748V10.3448H4.59485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M4.59485 9.03341V10.346H5.90748V9.03341H4.59485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M15.0945 11.6584V12.971H16.4071V11.6584H15.0945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M15.0945 10.346V11.6586H16.4071V10.346H15.0945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M15.0928 9.03341V10.346H16.4054V9.03341H15.0928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M7.2196 15.5953H8.53223V14.2827H7.2196V15.5953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M5.9071 14.2837H7.21973V12.9711H5.9071V14.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M13.7822 14.2825H12.4696V15.5952H13.7822V14.2825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M15.0929 12.9701H13.7803V14.2827H15.0929V12.9701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M9.84485 5.09644H8.53223V6.40906H9.84485V5.09644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M11.1572 5.09644H9.8446V6.40906H11.1572V5.09644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M12.4697 5.09644H11.1571V6.40906H12.4697V5.09644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M7.2196 7.72081H8.53223V6.40818H7.2196V7.72081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M5.9071 9.03326H7.21973V7.72063H5.9071V9.03326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M13.7822 6.40804H12.4696V7.72066H13.7822V6.40804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M13.7822 7.7207H12.4696V9.03333H13.7822V7.7207Z",
    fill: "#22A2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M15.0929 9.03326H13.7803V10.3459H15.0929V9.03326Z",
    fill: "#22A2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M12.4697 6.40804H11.1571V7.72066H12.4697V6.40804Z",
    fill: "#22A2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M15.0929 7.72081H13.7803V9.03343H15.0929V7.72081Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M13.7826 11.6586H12.47V12.9712H13.7826V11.6586Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M17.0641 4.43935H15.7515V5.75197H17.0641V4.43935Z",
    fill: "#22A2C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M15.7517 3.12668H14.4391V4.43931H15.7517V3.12668Z",
    fill: "#22A2C4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.10ce0b8e1ce968c0b6ed4ac95b9037b7.svg";
export { ForwardRef as ReactComponent };